/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeLogin_viewer = {
    readonly user: {
        readonly id: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"LoginBtn_viewer">;
    readonly " $refType": "ChromeLogin_viewer";
};
export type ChromeLogin_viewer$data = ChromeLogin_viewer;
export type ChromeLogin_viewer$key = {
    readonly " $data"?: ChromeLogin_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeLogin_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChromeLogin_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LoginBtn_viewer"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '51098dc072c6e760e5206e8ca82d6ffe';
export default node;
